import React from 'react';
import { BsPinAngle, BsPinAngleFill, BsFullscreen, BsFullscreenExit } from "react-icons/bs";
import './ToolHeader.css';

interface ToolHeaderProps {
  isPinned: boolean;
  onTogglePin: (pinned: boolean) => void;
  isFullscreen?: boolean;
  onToggleFullscreen?: (fullscreen: boolean) => void;
  toolType: 'note' | 'chat';
}

const ToolHeader: React.FC<ToolHeaderProps> = ({
  isPinned,
  onTogglePin,
  isFullscreen,
  onToggleFullscreen,
  toolType
}) => {
  return (
    <div className="tool-header-container">
      <div className="tool-header-buttons">
        {/* Fullscreen button */}
        <button 
          className={`${toolType}-fullscreen-button tool-header-button`}
          onClick={(e) => {
            e.stopPropagation();
            if (onToggleFullscreen) {
              onToggleFullscreen(!isFullscreen);
            }
          }}
          title={isFullscreen ? "Exit fullscreen" : "Enter fullscreen"}
        >
          {isFullscreen ? <BsFullscreenExit /> : <BsFullscreen />}
        </button>
        
        {/* Pin button */}
        <button 
          className={`${toolType}-pin-button tool-header-button`}
          onClick={(e) => {
            e.stopPropagation();
            onTogglePin(!isPinned);
          }}
          title={isPinned ? `Unpin ${toolType}` : `Pin ${toolType}`}
        >
          {isPinned ? <BsPinAngleFill /> : <BsPinAngle />}
        </button>
      </div>
    </div>
  );
};

export default ToolHeader; 